export const SITE_URL = "https://www.clean-force.eu";
export const DEFAULT_LANG = "nl";
export const LANGS = ["nl", "en", "fr", "de"];

export const HREFLANG = { nl: "nl", en: "en", fr: "fr", de: "de" };
export const LANG_LABELS = { nl: "Nederlands", en: "English", fr: "Français", de: "Deutsch" };
export const OG_LOCALE = { nl: "nl_NL", en: "en_GB", fr: "fr_FR", de: "de_DE" };

export const PAGES = {
  "/": {
    title: {
      nl: "Clean-Force BV | Schoonmaakbedrijf Nederland & België",
      en: "Clean-Force BV | Cleaning Company Netherlands & Belgium",
      fr: "Clean-Force BV | Entreprise de nettoyage Pays-Bas & Belgique",
      de: "Clean-Force BV | Reinigungsunternehmen Niederlande & Belgien",
    },
    description: {
      nl: "Professioneel schoonmaakbedrijf voor bedrijven en particulieren in Nederland en België. Kantoorschoonmaak, opleverschoonmaak, glazenwassen en meer.",
      en: "Professional cleaning company for businesses and individuals in the Netherlands and Belgium. Office cleaning, handover cleaning, window cleaning and more.",
      fr: "Entreprise de nettoyage professionnelle aux Pays-Bas et en Belgique. Nettoyage de bureaux, remise en état, lavage de vitres et plus.",
      de: "Professionelles Reinigungsunternehmen in den Niederlanden und Belgien. Büroreinigung, Übergabereinigung, Fensterreinigung und mehr.",
    },
    priority: 1.0,
  },
  "/diensten/schoonmaak-na-verhuur": {
    title: {
      nl: "Opleverschoonmaak na verhuur | Prijzen 2026 | Clean-Force",
      en: "Move-out cleaning | Prices 2026 | Clean-Force",
      fr: "Nettoyage de remise après location | Prix 2026 | Clean-Force",
      de: "Übergabereinigung nach Vermietung | Preise 2026 | Clean-Force",
    },
    description: {
      nl: "Opleverschoonmaak na verhuur, verkoop of verhuizing in NL en BE. Vaste pakketprijzen vanaf € 272,50 incl. btw. Grotere kans op volledige waarborg terug.",
      en: "Move-out cleaning after rental, sale or relocation in NL and BE. Fixed package prices from €272.50 incl. VAT. Greater chance of full deposit return.",
      fr: "Nettoyage de remise après location, vente ou déménagement. Prix forfaitaires à partir de 272,50 € TTC. Plus de chances de récupérer la caution.",
      de: "Übergabereinigung nach Vermietung, Verkauf oder Umzug in NL und BE. Festpreise ab 272,50 € inkl. MwSt. Höhere Chance auf volle Kaution.",
    },
    priority: 0.9,
  },
  "/diensten/kantoorschoonmaak": {
    title: {
      nl: "Kantoorschoonmaak | Tarieven & offerte | Clean-Force",
      en: "Office cleaning | Rates & quotes | Clean-Force",
      fr: "Nettoyage de bureaux | Tarifs & devis | Clean-Force",
      de: "Büroreinigung | Tarife & Angebot | Clean-Force",
    },
    description: {
      nl: "Professionele kantoorschoonmaak in Nederland en België. Vaste schoonmaakteams, flexibele frequentie en transparante tarieven per m² of per uur.",
      en: "Professional office cleaning in the Netherlands and Belgium. Dedicated cleaning teams, flexible frequency and transparent rates per m² or per hour.",
      fr: "Nettoyage professionnel de bureaux aux Pays-Bas et en Belgique. Équipes dédiées, fréquence flexible et tarifs transparents au m² ou à l'heure.",
      de: "Professionelle Büroreinigung in den Niederlanden und Belgien. Feste Reinigungsteams, flexible Frequenz und transparente Tarife pro m² oder Stunde.",
    },
    priority: 0.8,
  },
  "/diensten/industriele-reiniging": {
    title: {
      nl: "Industriële reiniging | Hallen & productie | Clean-Force",
      en: "Industrial cleaning | Halls & production | Clean-Force",
      fr: "Nettoyage industriel | Halls & production | Clean-Force",
      de: "Industrielle Reinigung | Hallen & Produktion | Clean-Force",
    },
    description: {
      nl: "Industriële reiniging van productiehallen, machines en logistieke ruimtes in NL en BE. Werken op hoogte, hogedruk en periodiek onderhoud.",
      en: "Industrial cleaning of production halls, machines and logistics spaces in NL and BE. Working at height, high pressure and periodic maintenance.",
      fr: "Nettoyage industriel de halls de production, machines et espaces logistiques. Travail en hauteur, haute pression et entretien périodique.",
      de: "Industrielle Reinigung von Produktionshallen, Maschinen und Logistikräumen in NL und BE. Arbeiten in der Höhe, Hochdruck und Wartung.",
    },
    priority: 0.8,
  },
  "/diensten/ramenwassen-osmose": {
    title: {
      nl: "Ramenwassen met osmose | Streeploos | Clean-Force",
      en: "Window cleaning with osmosis | Streak-free | Clean-Force",
      fr: "Lavage de vitres à l'osmose | Sans traces | Clean-Force",
      de: "Fensterreinigung mit Osmose | Streifenfrei | Clean-Force",
    },
    description: {
      nl: "Ramen wassen met osmosewater: streeploos resultaat zonder chemie, ook op hoogte. Vaste prijs per pand of per raam in Nederland en België.",
      en: "Window cleaning with osmosis water: streak-free results without chemicals, even at height. Fixed price per building or window in NL and BE.",
      fr: "Lavage de vitres à l'eau osmosée : résultat sans traces et sans produits chimiques, même en hauteur. Prix fixe par bâtiment ou fenêtre.",
      de: "Fensterreinigung mit Osmosewasser: streifenfreies Ergebnis ohne Chemie, auch in der Höhe. Festpreis pro Gebäude oder Fenster in NL und BE.",
    },
    priority: 0.8,
  },
  "/diensten/zonnepanelen-reiniging": {
    title: {
      nl: "Zonnepanelen reinigen | Meer opbrengst | Clean-Force",
      en: "Solar panel cleaning | More yield | Clean-Force",
      fr: "Nettoyage panneaux solaires | Plus de rendement | Clean-Force",
      de: "Solarreinigung | Mehr Ertrag | Clean-Force",
    },
    description: {
      nl: "Zonnepanelen professioneel laten reinigen met osmosewater. Herstel tot 15% rendementsverlies door vuil, mos en aanslag. Actief in NL en BE.",
      en: "Professional solar panel cleaning with osmosis water. Recover up to 15% yield loss from dirt, moss and deposits. Active in NL and BE.",
      fr: "Nettoyage professionnel de panneaux solaires à l'eau osmosée. Récupérez jusqu'à 15% de perte de rendement. Actif aux Pays-Bas et en Belgique.",
      de: "Professionelle Solarreinigung mit Osmosewasser. Bis zu 15% Ertragsverlust durch Schmutz und Moos wiederherstellen. Aktiv in NL und BE.",
    },
    priority: 0.8,
  },
  "/diensten/glazenwassen": {
    title: {
      nl: "Glazenwassen bedrijven & particulier | Clean-Force",
      en: "Window cleaning business & residential | Clean-Force",
      fr: "Lavage de vitres entreprises & particuliers | Clean-Force",
      de: "Glasreinigung Gewerbe & Privat | Clean-Force",
    },
    description: {
      nl: "Glazenwassen voor kantoren, winkels en woningen in Nederland en België. Periodiek of eenmalig, binnen en buiten, ook op hoogte.",
      en: "Window cleaning for offices, shops and homes in the Netherlands and Belgium. Periodic or one-off, inside and outside, even at height.",
      fr: "Lavage de vitres pour bureaux, commerces et habitations aux Pays-Bas et en Belgique. Périodique ou ponctuel, intérieur et extérieur.",
      de: "Glasreinigung für Büros, Geschäfte und Wohnungen in den Niederlanden und Belgien. Regelmäßig oder einmalig, innen und außen, auch in der Höhe.",
    },
    priority: 0.8,
  },
  "/diensten/vakantiehuizen": {
    title: {
      nl: "Schoonmaak vakantiehuizen & wissels | Clean-Force",
      en: "Holiday home cleaning & changeovers | Clean-Force",
      fr: "Nettoyage locations de vacances | Clean-Force",
      de: "Reinigung Ferienwohnungen & Wechsel | Clean-Force",
    },
    description: {
      nl: "Complete wisselschoonmaak voor vakantiewoningen: schoonmaak, linnenwissel en check-in. Betrouwbaar bij korte wisseltijden in NL en BE.",
      en: "Complete changeover cleaning for holiday rentals: cleaning, linen change and check-in. Reliable with short turnaround times in NL and BE.",
      fr: "Nettoyage complet entre les séjours : ménage, changement de linge et check-in. Fiable avec des délais courts aux Pays-Bas et en Belgique.",
      de: "Komplette Wechselreinigung für Ferienwohnungen: Reinigung, Wäschewechsel und Check-in. Zuverlässig bei kurzen Wechselzeiten in NL und BE.",
    },
    priority: 0.8,
  },
  "/diensten/wasserijdiensten": {
    title: {
      nl: "Wasserijdiensten voor bedrijven | Clean-Force",
      en: "Laundry services for businesses | Clean-Force",
      fr: "Services de blanchisserie pour entreprises | Clean-Force",
      de: "Wäschereidienste für Unternehmen | Clean-Force",
    },
    description: {
      nl: "Professionele wasserijdiensten voor horeca, zorg en verhuur. Ophalen, wassen, strijken en leveren volgens vaste route in NL en BE.",
      en: "Professional laundry services for hospitality, healthcare and rentals. Collection, washing, ironing and delivery on a fixed route in NL and BE.",
      fr: "Services de blanchisserie professionnels pour l'hôtellerie, les soins et la location. Collecte, lavage, repassage et livraison sur route fixe.",
      de: "Professionelle Wäschereidienste für Gastronomie, Pflege und Vermietung. Abholung, Waschen, Bügeln und Lieferung auf fester Route in NL und BE.",
    },
    priority: 0.8,
  },
  "/diensten/sanering-desinfectie": {
    title: {
      nl: "Sanering & Desinfectie | Spoedservice | Clean-Force",
      en: "Remediation & Disinfection | Emergency service | Clean-Force",
      fr: "Assainissement & Désinfection | Service d'urgence | Clean-Force",
      de: "Sanierung & Desinfektion | Notdienst | Clean-Force",
    },
    description: {
      nl: "Professionele sanering en desinfectie na wateroverlast, rioolbreuk of verstopt toilet. Spoedservice beschikbaar in NL en BE.",
      en: "Professional remediation and disinfection after water damage, sewer breakage or blocked toilet. Emergency service in NL and BE.",
      fr: "Assainissement et désinfection professionnels après dégât des eaux ou rupture d'égout. Service d'urgence aux Pays-Bas et en Belgique.",
      de: "Professionelle Sanierung und Desinfektion nach Wasserschaden oder Rohrbruch. Notdienst in NL und BE verfügbar.",
    },
    priority: 0.8,
  },
  "/diensten/bouwoplevering": {
    title: {
      nl: "Bouwoplevering schoonmaak | Instapklaar | Clean-Force",
      en: "Post-construction cleaning | Move-in ready | Clean-Force",
      fr: "Nettoyage après construction | Clé en main | Clean-Force",
      de: "Bauendreinigung | Einzugsfertig | Clean-Force",
    },
    description: {
      nl: "Opleveringsschoonmaak na nieuwbouw of renovatie. Stof, cement en verfspetters professioneel verwijderd. Instapklaar resultaat in NL en BE.",
      en: "Post-construction cleaning after new build or renovation. Dust, cement and paint splatters professionally removed. Move-in ready in NL and BE.",
      fr: "Nettoyage de fin de chantier après construction ou rénovation. Poussière, ciment et éclaboussures éliminés. Clé en main aux Pays-Bas et en Belgique.",
      de: "Bauendreinigung nach Neubau oder Renovierung. Staub, Zement und Farbspritzer professionell entfernt. Einzugsfertig in NL und BE.",
    },
    priority: 0.8,
  },
  "/diensten/deepclean": {
    title: {
      nl: "Deep Clean | Grondige dieptereiniging | Clean-Force",
      en: "Deep Clean | Thorough deep cleaning | Clean-Force",
      fr: "Deep Clean | Nettoyage en profondeur | Clean-Force",
      de: "Deep Clean | Gründliche Tiefenreinigung | Clean-Force",
    },
    description: {
      nl: "Grondige dieptereiniging van normaal tot extreem vervuild. Nicotine, verwaarlozing, huurschade — wij maken het weer schoon. NL en BE.",
      en: "Thorough deep cleaning from normal to extremely soiled. Nicotine, neglect, rental damage — we make it clean again. NL and BE.",
      fr: "Nettoyage en profondeur du normal à l'extrêmement sale. Nicotine, négligence, dommages locatifs — nous nettoyons tout. NL et BE.",
      de: "Gründliche Tiefenreinigung von normal bis extrem verschmutzt. Nikotin, Verwahrlosung, Mietschäden — wir reinigen alles. NL und BE.",
    },
    priority: 0.8,
  },
  "/blog": {
    title: {
      nl: "Blog — Kennis & Tips | Clean-Force BV",
      en: "Blog — Knowledge & Tips | Clean-Force BV",
      fr: "Blog — Connaissances & Conseils | Clean-Force BV",
      de: "Blog — Wissen & Tipps | Clean-Force BV",
    },
    description: {
      nl: "Praktische artikelen over professionele schoonmaak, onderhoud en hygiëne van Clean-Force.",
      en: "Practical articles about professional cleaning, maintenance and hygiene from Clean-Force.",
      fr: "Articles pratiques sur le nettoyage professionnel, l'entretien et l'hygiène par Clean-Force.",
      de: "Praktische Artikel über professionelle Reinigung, Wartung und Hygiene von Clean-Force.",
    },
    priority: 0.7,
  },
};

export function buildUrl(path, lang) {
  const clean = path === "/" ? "" : path;
  if (lang === DEFAULT_LANG) return `${SITE_URL}${clean || "/"}`;
  return `${SITE_URL}/${lang}${clean}`;
}

export function getPageMeta(path, lang) {
  const page = PAGES[path];
  if (!page) {
    console.warn(`[SEO] Route "${path}" not found in siteConfig PAGES. Falling back to homepage meta.`);
    return {
      title: `Clean-Force BV | ${lang === "nl" ? "Professioneel Schoonmaakbedrijf" : "Professional Cleaning"}`,
      description: PAGES["/"].description[lang] || PAGES["/"].description.nl,
    };
  }
  return {
    title: page.title[lang] || page.title.nl,
    description: page.description[lang] || page.description.nl,
  };
}
